import React, { useEffect, useRef, useState } from "react";
import {
  AddIconBlue,
  AddImageIcon,
  Arrowlinkicon,
  coachDemoImg,
  EditIconDarkGray,
  TrashIconGray,
  UserFallback,
  UserIconRed,
} from "../../../../constant/imagePath";
import { Button } from "../../../../stories/Button/Button";
import { UploadedImageWithEditAndDelete } from "../../../../stories/UploadedImageWithEditAndDelete/UploadedImageWithEditAndDelete";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import classes from "./PersonalInfo.module.css";
import EditPhotoModal from "../../../../components/Modals/CoachFlow/OnBoarding/EditPhoto/EditPhoto";
import { Container, Row, Col } from "react-bootstrap";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { Input } from "../../../../stories/Input/Input";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import DisableAccountModal from "../../../../components/Modals/CoachFlow/Settings/DisableAccount/DisableAccount";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import PersonalInfoMobile from "./PersonalInfoMobile";
const PersonalInfoDesktop = () => {
  // Cover Photo States
  const coverRef = useRef(null);
  const [coverPhoto, setCoverPhoto] = useState(coachDemoImg);

  const [fullName, setFullName] = useState("Hanna Specter");
  const [phoneNumber, setPhoneNumber] = useState("+16102458015");
  const [gender, setGender] = useState({ label: "Male", value: "Male" });
  const [dateOfBirth, setDateOfBirth] = useState("22/04/1992");
  const [email, setEmail] = useState("john.johnson@gmail.com");
  const [aboutMe, setAboutMe] = useState("");

  const [sportsType, setSportsType] = useState();
  const [experienceLevel, setERxperienceLevel] = useState();

  const [password, setPassword] = useState();
  const [newpassword, setNewPassword] = useState();
  const [confirmpassword, setConfirmPassword] = useState();

  const [disableModal, setDisableModal] = useState(false);

  const [isEditingCover, setIsEditingCover] = useState(false);
  const addCoverPhoto = () => {
    coverRef.current.click();
  };

  const deleteCoverPhoto = () => {
    setCoverPhoto("");
  };
  return (
    <div>
      <div className={[classes.editPhotoMainDiv]}>
        <div className={classes.imageUpdated}>
          <img src={coverPhoto} onError={(e) => {
            e.target.onerror = null
            e.target.src = UserFallback
          }} />
        </div>

        <div className={classes.editPhotoInnerDiv}>
          <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
            Add your profile pic
          </h5>
          <p style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p1 }}>
            Upload PNG or JPEG file. File size limit is up to 5MB
          </p>
          <div className={classes.imageControls}>
            <Button
              onClick={addCoverPhoto}
              primary={true}
              label="Upload new picture"
              customStyle={{
                marginRight: "10px",
                width: "179px",
                padding: "0px",
                ...Fonts.b3,
              }}
            />
            <Button
              icon={TrashIconGray}
              onClick={deleteCoverPhoto}
              primary={false}
              customStyle={{
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            />
          </div>
        </div>
      </div>

      <input
        className="d-none"
        accept="image/*"
        type={"file"}
        ref={coverRef}
        onChange={(e) => {
          console.log("aaa");
          setCoverPhoto(e.target.files[0]);
          setIsEditingCover(true);
        }}
        onClick={(event) => {
          event.target.value = null;
        }}
      />

      <Row className={[classes.formRow]}>
        <Col lg={6} xl={5} className={[classes.formCol]}>
          <Input
            label="Full Name"
            state={fullName}
            setter={setFullName}
            placeholder=""
          />
        </Col>
        <Col lg={6} xl={5} className={[classes.formCol]}>
          <Input
            label="Phone Number (Optional)"
            state={phoneNumber}
            setter={setPhoneNumber}
            placeholder=""
          />
        </Col>
        <Col lg={6} xl={5} className={[classes.formCol]}>
          <DropDown
            label="Gender"
            state={gender}
            setter={setGender}
            options={[
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
              { label: "Other", value: "Other" },
            ]}
          />
        </Col>
        <Col lg={6} xl={5} className={[classes.formCol]}>
          <Input
            type="date"
            label="Date Of Birth"
            state={dateOfBirth}
            setter={setDateOfBirth}
            placeholder=""
          />
        </Col>
        <Col lg={6} xl={5} className={[classes.formEmailCol]}>
          <Input
            label="Email address"
            state={email}
            setter={setEmail}
            placeholder=""
          />
          <Row>
            <Col md={6}>
              <DropDown
                label="Sport type"
                state={sportsType}
                setter={setSportsType}
                placeholder="Sport type"
                options={[
                  { label: "Tennis", value: "Tennis" },
                  { label: "Basketball", value: "Basketball" },
                  { label: "Football", value: "Football" },
                ]}
              />
            </Col>
            <Col lg={6} xl={5}>
              <DropDown
                label="Experience level"
                placeholder="Experience"
                state={experienceLevel}
                setter={setERxperienceLevel}
                options={[
                  { label: "Beginner", value: "Beginner" },
                  { label: "Intermediate", value: "Intermediate" },
                  { label: "Competitor", value: "Competitor" },
                ]}
              />
            </Col>
          </Row>
        </Col>

        <Col lg={6} xl={5} className={[classes.formlastCol]}>
          <TextArea
            label="About me"
            state={aboutMe}
            setter={setAboutMe}
            placeholder="Drop a few sentences about yourself..."
          />
        </Col>
        <Col md={12}>
          <LinkButtonWithIcon
            customStyle={{
              ...Fonts.b2,
              fontSize: "14px",
              lineHeight: "20px",
              border: "none",
              marginBottom: "40px",
            }}
            primary={true}
            text="Add experience"
            leftIcon={AddIconBlue}
          />
        </Col>
        <Col lg={6} xl={5}>
          <Button
            primary={true}
            disabled={true}
            label="Save changes"
            customStyle={{
              width: "180px",
              padding: "0px",
              ...Fonts.b3,
            }}
          />
        </Col>
      </Row>

      <Row className={[classes.mb32].join(" ")}>
        <Col lg={6} xl={5}>
          <h5
            style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
            className={`${classes.mb32}`}
          >
            Privacy Settings
          </h5>
          <Input
            type="password"
            state={password}
            setter={setPassword}
            label="Current password"
            placeholder={"Enter current password"}
          />
        </Col>
      </Row>

      <Row className={[classes.mb32].join(" ")}>
        <Col lg={6} xl={5}>
          <Input
            type="password"
            state={newpassword}
            setter={setNewPassword}
            label="New password"
            placeholder={"Enter new password"}
          />
        </Col>

        <Col lg={6} xl={5}>
          <Input
            type="password"
            state={confirmpassword}
            setter={setConfirmPassword}
            label="Confirm New password"
            placeholder={"Re-enter new password"}
          />
        </Col>
      </Row>

      <div
        className={[classes.BtnDiv]}
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
      >
        <Button
          primary={false}
          size={'Large'}
          customStyle={{ marginRight: "16px", width: 'max-content', padding: '12px 36px' }}
        >
          Cancel
        </Button>
        <Button primary={true}
          customStyle={{ width: 'max-content', padding: '12px 36px' }}
          size={'Large'}

        >
          Save changes
        </Button>
      </div>

      <div className={[classes.dflex, classes.mb80].join(" ")}>
        <p
          style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
          className={[classes.mr10].join(" ")}
        >
          Can't remember your current password?
        </p>
        <LinkButtonWithIcon
          rightIcon={Arrowlinkicon}
          text="Reset password via email"
          primary={true}
          customStyle={{
            ...Fonts.p1,
            fontSize: "16px",
            lineHeight: "16px",
          }}
        />
      </div>

      <Row>
        <Col lg={6} xl={5}>
          <h5
            style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
            className={`${classes.mb12}`}
          >
            Disable account
          </h5>
          <p
            style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            className={[classes.mb24].join(" ")}
          >
            <span style={{ color: Colors.errorColor, ...Fonts.h7, fontFamily: 'inter-600', lineHeight: '24px' }}>
              PLEASE NOTE!
            </span>{" "}
            This means your account will be hidden until you reactivate it by
            logging back in.
          </p>
          <div className={[classes.disablebtnwidth].join(" ")}>
            <Button
              primary={false}
              onClick={() => setDisableModal(!disableModal)}
              size={'Large'}
              customStyle={{ width: "max-content", padding: '12px 32px' }}
            >
              Disable the account
            </Button>
          </div>
        </Col>
      </Row>

      {/* Edit Photo Modal */}
      {isEditingCover && (
        <EditPhotoModal
          show={isEditingCover}
          setShow={setIsEditingCover}
          state={coverPhoto}
          onSave={setCoverPhoto}
        />
      )}

      <DisableAccountModal show={disableModal} setShow={setDisableModal} />
    </div>
  );
};

const PersonalInfo = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PersonalInfoMobile /> : <PersonalInfoDesktop />;
};

export default PersonalInfo;
